export default "__VITE_ASSET__CPNHSbl6__"